<template>
	<div class="productBox">
		<div class="flex">
			<div class="left mt-4">
				<img class="product-img" :src="row.product_pic" alt="" />
				<div class="handler" v-if="injectIsSampleOrder && $auth.hasPermi('system:goods:promote')">
					<div @click="show(row)">我要推广</div>
				</div>
			</div>
			<div class="right flex-column ml-10">
				<div class="flex flex-align-center name">
					<platform-icon :platformId="row.platform_id"></platform-icon>
					<el-tooltip class="item" effect="dark" :content="row.product_name" placement="top">
						<p class="ml-10 yx-color-pure-1 product_name" @click="skipFun">{{ row.product_name }}</p>
					</el-tooltip>
					<el-tooltip v-if="$isPlatOr(row.platform_id, ['Dy', 'Sp'])" placement="top" :content="content" :disabled="$isSp(row.platform_id)">
						<div class="tagLink radius-4 ml-4 font-h6-regular yx-color-text-regular cursor-pointer hover" @click="copyLink()">
							<i class="el-icon-link"></i>
						</div>
					</el-tooltip>
				</div>
				<p class="fz-12 yx-color-text-secondary">
					商品ID：
					<span class="yx-color-text-secondary">{{ row.third_product_id }}</span>
				</p>
				<p class="fz-12 yx-color-text-secondary flex-row-align-center" v-if="tabName === '1'">
					<span>店铺：</span>
					<span class="yx-color-text-secondary mr-6 line-ellipsis-1" v-ak-tooltip-auto-show style="max-width: 60px">{{ row.shop_name }}</span>
					<ID-tag label="店铺ID" :id="row.shop_id" />
					<template v-if="injectIsSampleOrder">
						<span class="cursor-pointer" @click="toSearchEvent(row)">
							<span class="ml-12">同店</span>
							<span class="primary-color pl-2 pr-2">{{ row.wait_delivery_num }}</span>
							<span>款待发货</span>
						</span>
					</template>
				</p>
				<div class="mt-2 mb-4" v-if="row.collaborative_status == '1' && injectIsSampleOrder && vuex_isshopurl">
					<span class="shop-bind-tag radius-4 font-h6-regular">
						<i class="check-double-fill"></i>
						店铺已绑定商团协作
					</span>
				</div>
				<div class="flex fz-12 yx-color-text-secondary" v-if="!injectIsSampleOrder">
					团长：
					<span class="yx-color-text-secondary mr-6">{{ row.institution_name | textFormat(4) }}</span>
					<ID-tag label="团长ID" :id="row.authority_id | formatEmpty" />
					<div v-if="statusState" class="authority-status yx-color-text-regular">{{ row.authority_status }}</div>
				</div>
				<p class="fz-12 yx-color-info" v-if="injectIsSampleOrder">
					现售价：
					<span class="yx-color-text-regular">￥{{ row.sale_price }}</span>
				</p>
				<p class="fz-12 yx-color-info">
					<span class="pr-8" v-if="injectIsSampleOrder">
						佣金率：
						<span class="yx-color-text-regular">{{ row.commission_rate || '-' }} %</span>
					</span>
					<span v-if="isShow && (tabName === '0' || tabName === '1') && $auth.hasPermi('system:goods-ServiceRate')">
						服务费率：
						<span class="yx-color-text-regular">{{ row.service_rate || '-' }} %</span>
					</span>
				</p>

				<div class="tags">
					<p class="partner-tag mr-6">{{ row.product_type_name }}</p>
					<el-tooltip
						v-if="showTag"
						content="该合作进度已与商家账号同步，商家可协助进行寄样、确认带货、更换带货链接、校验链接、确认开播等操作"
						placement="top"
					>
						<div class="tag mt-4">
							<span>已同步</span>
							<div class="iconfont icon-a-help-circle-obangzhu-xian"></div>
						</div>
					</el-tooltip>
					<div class="reissue" v-if="row.is_reissue == '1'">补发样品</div>
					<el-tooltip v-if="retailInfo.tag" :content="retailInfo.tooltip" placement="top">
						<div :class="retailInfo.className">{{ retailInfo.tag }}</div>
					</el-tooltip>
					<p class="reissue goodsDescTag" v-if="tabName !== '0' && is_good_type">{{ row.sell_goods_desc }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getSourceUrl } from '@/api/shopManage';
import { mapGetters, mapState } from 'vuex';
import { copyFun } from '@/utils/common';
import IDTag from '@/components/ui/IDTag';
import { copy } from '@/utils/common';

export default {
	name: 'productBox',
	components: {
		IDTag,
	},
	inject: {
		injectIsSampleOrder: {
			default: () => false,
		},
	},
	props: {
		isShow: {
			type: Boolean,
			default: false,
		},
		row: {
			type: Object,
			default: () => ({}),
		},
		tabName: {
			type: [String, Number],
			default: '',
		},
		is_good_type: {
			type: Number,
			default: 0,
		},
		showTag: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...mapGetters(['isDarenPartner']),
		...mapState(['vuex_isshopurl']),
		retailInfo() {
			const { retail_type = '' } = this.row;
			const arr = [
				{ tag: '达人分销', tooltip: '直接与达人合作，由达人直接进行分销带货', className: 'talent-tag' },
				{ tag: '团长分销', tooltip: '报名了二级团长活动，由二级团长找达人进行分销带货', className: 'partner-tag' },
			];
			return arr[retail_type] || {};
		},
		statusState() {
			const { authority_status = '' } = this.row;
			return authority_status && authority_status !== '已授权';
		},
		content() {
			// 保持不变
			return this.isDarenPartner
				? this.row.source_type === '2'
					? '专属链接，达人使用该链接带货产生的订单归属为您的业绩。'
					: '该链接非团长商品链接，达人使用该链接(托管商品链接除外)带货产生的订单无法统计到团队业绩。'
				: `非专属链接，达人使用该链接带货产生的订单无法归属到${this.drName}。请前往${this.drName}账号复制专属链接。`;
		},
	},
	data() {
		return {};
	},
	methods: {
		async skipFun() {
			if (this.$isSp(this.row.platform_id)) {
				return;
			}
			const {
				isDarenPartner,
				row: { product_id, cooperate_id, product_url },
				handLink,
			} = this;
			// 保持不变
			if (isDarenPartner) {
				const { code, data } = await getSourceUrl({ product_id, cooperate_id });
				if (code === 0) {
					let link = data.pick_source;
					handLink(link);
				}
			} else {
				handLink(product_url);
			}
		},
		handLink(link) {
			var a = document.createElement('a');
			a.setAttribute('href', link);
			a.setAttribute('target', '_blank');
			a.setAttribute('id', 'startTelMedicine');
			// 防止反复添加
			if (document.getElementById('startTelMedicine')) {
				document.body.removeChild(document.getElementById('startTelMedicine'));
			}
			document.body.appendChild(a);
			a.click();
		},
		show(row) {
			row?.openShareDrawerEvent(row);
		},
		handleCopy(id) {
			copy(id);
			this.$message.success('复制成功');
		},
		copyLink() {
			copyFun(this.row, this, '1');
		},
		toSearchEvent(row) {
			//样品订单
			this.$Bus.$emit('ShopSearchEvent', row);
		},
	},
};
</script>

<style lang="less" scoped>
.productBox {
	width: 350px;
	.handler {
		position: absolute;
		top: 40px;
		border-radius: 0 0 2px 2px;
		left: 0;
		right: 0;
		width: 100%;
		height: 24px;
		line-height: 24px;
		display: flex;
		justify-content: center;
		opacity: 0;
		background-color: #7052ff;
		color: #fff;
		font-size: 12px;
		cursor: pointer;
	}

	&:hover {
		.handler {
			opacity: 1;
		}
	}
}
.header {
	border-radius: 1px solid #eeeeee;
}
.left {
	flex-shrink: 0;
	overflow: hidden;
	position: relative;
}
.left img {
	width: 64px;
	height: 64px;
}
.name img {
	width: 16px;
	height: 16px;
}
.product_name {
	cursor: pointer;
	width: 180px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.product_name:hover {
	color: @color-success;
}
.team_pro {
	border-radius: 3px;
	height: 18px;
	line-height: 18px;
	border-radius: 3px;
	text-align: center;
	width: 60px;
	background-color: @color-gy1;
	border: 1px solid @color-b2;
	color: @color-primary;
}
.reissue {
	width: 56px;
	height: 18px;
	line-height: 18px;
	padding: 0 4px;
	background-color: #fef3e7;
	border-radius: 2px;
	font-size: 12px;
	color: #fa8f14;
	text-align: center;
	margin-top: 4px;
}
.goodsDescTag {
	width: auto;
}
.tag {
	display: flex;
	align-items: center;
	padding: 0 4px;
	font-size: 12px;
	background-color: #fef3e7;
	border-radius: 1px;
	line-height: 18px;
	color: #fa8f14;
	width: 62px;
	white-space: nowrap;
	.iconfont {
		transform: scale(0.83);
		margin-left: 2px;
	}
}
.tags {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	:nth-child(n) {
		margin-right: 4px;
	}
}
.partner-tag,
.talent-tag {
	height: 18px;
	line-height: 18px;
	border-radius: 2px;
	text-align: center;
	font-size: 12px;
	margin-top: 4px;
	padding: 0 5px;
}
.partner-tag {
	background-color: @color-gy1;
	border: 1px solid @color-b2;
	color: @color-primary;
	border-radius: 3px;
}
.talent-tag {
	background-color: rgb(255, 238, 237);
	color: rgb(250, 42, 23);
}
.shop-bind-tag {
	padding: 0 4px;
	display: inline;
	height: 18px;
	line-height: 18px;
	border: 1px solid #cff1d2;
	color: @color-g;
}
.tag-lable {
	padding: 0 3px;
	height: 17px;
	border-radius: 3px;
	background-color: @color-gy2;
	margin-left: 4px;
}
.authority-status {
	margin-left: 4px;
	line-height: 20px;
	padding: 0 3px 0 3px;
	height: 20px;
	border-radius: 3px;
	border: 1px solid @color-gy4;
	font-size: 12px;
	font-family: PingFangSC-Regular;
}
.product-img {
	border-radius: 4px;
}
.tagLink {
	padding: 0 3px;
	border-radius: 3px;
	background-color: #f7f8fa;
	margin-left: 4px;
}
</style>
